import { enableAsyncPricingApi } from "./Utils/features";

export const msalConfig = {
	auth: {
		clientId: process.env.REACT_APP_AD_CLIENT_ID,
		authority: process.env.REACT_APP_AD_AUTHORITY,
		redirectUri: process.env.REACT_APP_AD_REDIRECT_URI,
	},
	cache: {
		cacheLocation: "sessionStorage",
		storeAuthStateInCookie: false,
	}
};

export const loginRequest = {
	scopes: [
		"User.Read"
	]
};

export const getApiRequestByUrl = (url) => {
	if (url) {

		if (url.indexOf('status/batches') !== -1) {
			return statusMonitorReadApiRequest;
		}

		if (url.indexOf('status/event') !== -1) {
			return statusMonitorCreateApiRequest;
		}

		if (url.indexOf('dataaccess') !== -1) {
			return batchDataRequest;
		}

		if (url.indexOf('submissions') !== -1) {
			return submissionReadApiRequest;
		}

	}

	return pricerApiRequest;
};

export const statusMonitorReadApiRequest = {
	scopes: [
		process.env.REACT_APP_STATUS_MONITOR_API_READ_SCOPE
	]
};

export const statusMonitorCreateApiRequest = {
	scopes: [
		process.env.REACT_APP_STATUS_MONITOR_API_CREATE_SCOPE
	]
};

export const batchDataRequest = {
	scopes: [
		process.env.REACT_APP_BATCH_DATA_ACCESS_READ_SCOPE
	]
};

export const submissionReadApiRequest = {
	scopes: [
		process.env.REACT_APP_SUBMISSIONAPI_READ_SCOPE
	]
} ;

export const submissionCreateApiRequest = {
	scopes: [
		process.env.REACT_APP_SUBMISSIONAPI_CREATE_SCOPE
	]
}
